export default __webpack_public_path__ + "static/media/4g-tbox.59b19f5e.jpg";